import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { IEntityReducer } from '../../../reducers/entities';
import { parseAction, parseActionDAO } from './action';
import { EntityTypes } from 'constants/entities';
import { getEntities } from 'core/selectors/utils/getEntities';
import { IAction, IActionBasic, IActionEntity } from 'types/domain/action';
import { IKeyArray } from 'types/IKeyArray';
import { createCachedSelector } from 're-reselect';

const entity = (state: RootState) => state.entity.present;
const moduleId = (state: RootState, id?) => id || state.state[EntityTypes.MODULE];

export const selectActions = createSelector([entity, moduleId], (entity: IEntityReducer, moduleId: number) => {
  return getEntities(entity, EntityTypes.ACTION, 'moduleId', moduleId).reduce((prev, action) => {
    return {
      ...prev,
      [action.id]: parseAction(entity, action.id),
    };
  }, {}) as IKeyArray<IActionBasic>;
});

export const selectActionsHaveNodes = createSelector([entity, moduleId], (entity: IEntityReducer, moduleId: number) => {
  return getEntities(entity, EntityTypes.ACTION, 'moduleId', moduleId).some((a: IAction) => !!a.nodeId);
});

export const selectActionsIsCorrect = createCachedSelector(
  [entity, moduleId],
  (entity: IEntityReducer, moduleId: number) => {
  
    if (entity[EntityTypes.MODULE][moduleId]?.assess) return true;

    return getEntities(entity, EntityTypes.ACTION, 'moduleId', moduleId).some((a: IAction) =>
      getEntities(entity, EntityTypes.ACTION_ENTITY, 'actionId', a.id).some((en: IActionEntity) => en.correct),
    );
  },
)((state, id) => id || state.state[EntityTypes.MODULE]);
